import React, { useState, useEffect } from 'react';
import '../styles/PhoneInput.css';

// Коды стран с флагами
const countryCodes = [
    { code: '+7', country: 'RU', flag: '🇷🇺', priority: 1 },
    { code: '+1', country: 'US', flag: '🇺🇸', priority: 2 },
    { code: '+55', country: 'BR', flag: '🇧🇷', priority: 3 },
    { code: '+49', country: 'DE', flag: '🇩🇪', priority: 4 },
    { code: '+33', country: 'FR', flag: '🇫🇷', priority: 5 },
    { code: '+44', country: 'GB', flag: '🇬🇧', priority: 6 },
    { code: '+39', country: 'IT', flag: '🇮🇹', priority: 7 },
    { code: '+34', country: 'ES', flag: '🇪🇸', priority: 8 },
    { code: '+86', country: 'CN', flag: '🇨🇳', priority: 9 },
    { code: '+81', country: 'JP', flag: '🇯🇵', priority: 10 },
    { code: '+82', country: 'KR', flag: '🇰🇷', priority: 11 },
    { code: '+91', country: 'IN', flag: '🇮🇳', priority: 12 },
    { code: '+61', country: 'AU', flag: '🇦🇺', priority: 13 },
    { code: '+31', country: 'NL', flag: '🇳🇱', priority: 14 },
    { code: '+46', country: 'SE', flag: '🇸🇪', priority: 15 },
    { code: '+47', country: 'NO', flag: '🇳🇴', priority: 16 },
    { code: '+45', country: 'DK', flag: '🇩🇰', priority: 17 },
    { code: '+358', country: 'FI', flag: '🇫🇮', priority: 18 },
    { code: '+41', country: 'CH', flag: '🇨🇭', priority: 19 },
    { code: '+43', country: 'AT', flag: '🇦🇹', priority: 20 },
    { code: '+32', country: 'BE', flag: '🇧🇪', priority: 21 },
    { code: '+48', country: 'PL', flag: '🇵🇱', priority: 22 },
    { code: '+420', country: 'CZ', flag: '🇨🇿', priority: 23 },
    { code: '+421', country: 'SK', flag: '🇸🇰', priority: 24 },
    { code: '+36', country: 'HU', flag: '🇭🇺', priority: 25 },
    { code: '+40', country: 'RO', flag: '🇷🇴', priority: 26 },
    { code: '+359', country: 'BG', flag: '🇧🇬', priority: 27 },
    { code: '+385', country: 'HR', flag: '🇭🇷', priority: 28 },
    { code: '+386', country: 'SI', flag: '🇸🇮', priority: 29 },
    { code: '+381', country: 'RS', flag: '🇷🇸', priority: 30 },
    { code: '+30', country: 'GR', flag: '🇬🇷', priority: 31 },
    { code: '+90', country: 'TR', flag: '🇹🇷', priority: 32 },
    { code: '+380', country: 'UA', flag: '🇺🇦', priority: 33 },
    { code: '+375', country: 'BY', flag: '🇧🇾', priority: 34 },
    { code: '+371', country: 'LV', flag: '🇱🇻', priority: 35 },
    { code: '+370', country: 'LT', flag: '🇱🇹', priority: 36 },
    { code: '+372', country: 'EE', flag: '🇪🇪', priority: 37 },
    { code: '+998', country: 'UZ', flag: '🇺🇿', priority: 38 },
    { code: '+7', country: 'KZ', flag: '🇰🇿', priority: 39 },
    { code: '+996', country: 'KG', flag: '🇰🇬', priority: 40 },
    { code: '+992', country: 'TJ', flag: '🇹🇯', priority: 41 },
    { code: '+993', country: 'TM', flag: '🇹🇲', priority: 42 },
    { code: '+374', country: 'AM', flag: '🇦🇲', priority: 43 },
    { code: '+994', country: 'AZ', flag: '🇦🇿', priority: 44 },
    { code: '+995', country: 'GE', flag: '🇬🇪', priority: 45 },
    { code: '+373', country: 'MD', flag: '🇲🇩', priority: 46 }
];

const PhoneInput = ({ value = '', onChange, disabled = false, placeholder = '+7 999 999 99 99' }) => {
    const [inputValue, setInputValue] = useState('');
    const [detectedCountry, setDetectedCountry] = useState(null);

    // Определение страны по введенному коду
    const detectCountryFromInput = (input) => {
        const cleanInput = input.replace(/[^\d+]/g, '');

        // Ищем подходящий код страны
        for (const country of countryCodes) {
            if (cleanInput.startsWith(country.code)) {
                return country;
            }
        }
        return null;
    };

    // Форматирование номера телефона
    const formatPhoneNumber = (input) => {
        // Убираем все кроме цифр и +
        let cleaned = input.replace(/[^\d+]/g, '');

        // Если не начинается с +, добавляем
        if (cleaned && !cleaned.startsWith('+')) {
            cleaned = '+' + cleaned;
        }

        // Ограничиваем длину
        if (cleaned.length > 16) {
            cleaned = cleaned.slice(0, 16);
        }

        // Добавляем пробелы для удобочитаемости
        if (cleaned.length > 1) {
            // Находим код страны
            const country = detectCountryFromInput(cleaned);
            if (country) {
                const codeLength = country.code.length;
                const afterCode = cleaned.slice(codeLength);

                // Форматируем в зависимости от длины
                let formatted = country.code;
                if (afterCode.length > 0) {
                    formatted += ' ';
                    // Группируем цифры: 3-3-2-2
                    for (let i = 0; i < afterCode.length; i++) {
                        if (i === 3 || i === 6 || i === 8) {
                            formatted += ' ';
                        }
                        formatted += afterCode[i];
                    }
                }
                return formatted;
            }
        }

        return cleaned;
    };

    useEffect(() => {
        if (value) {
            const formatted = formatPhoneNumber(value);
            setInputValue(formatted);
            setDetectedCountry(detectCountryFromInput(value));
        }
    }, [value]);

    const handleInputChange = (e) => {
        const newValue = e.target.value;
        const formatted = formatPhoneNumber(newValue);

        setInputValue(formatted);

        // Определяем страну
        const country = detectCountryFromInput(formatted);
        setDetectedCountry(country);

        // Отправляем очищенное значение (без пробелов) в родительский компонент
        const cleanValue = formatted.replace(/\s/g, '');
        onChange({ target: { value: cleanValue } });
    };

    return (
        <div className="phone-input-container">
            <div className="phone-input-flag-inside" style={{ display: 'none' }}>
                {detectedCountry ? detectedCountry.flag : '🌍'}
            </div>
            <input
                className="phone-input-field"
                type="text"
                value={inputValue}
                onChange={handleInputChange}
                placeholder={placeholder}
                disabled={disabled}
            />
        </div>
    );
};

export default PhoneInput;
